<template>
  <auth-layout>
    <component :is="component" />
  </auth-layout>
</template>

<script>
import AuthLayout from '@/components/auth/components/AuthLayout.vue'
import AuthResetPassword from '@/components/auth/resetPassword/AuthResetPassword.vue'
import AuthRegistration from '@/components/auth/registration/AuthRegistration.vue'
import AuthLogin from '@/components/auth/login/AuthLogin.vue'
import AuthForgotPassword from '@/components/auth/forgotPassword/AuthForgotPassword.vue'
import AuthResetPasswordSuccess from '@/components/auth/resetPassword/AuthResetPasswordSuccess.vue'
import ConfirmEmail from '@/email/ConfirmEmail.vue'
import AuthErrorComponents from '@/components/auth/authErrorс/AuthErrorComponents.vue'
import AuthTwoFa from '@/components/auth/auth2Fa/AuthTwoFa.vue'

export default {
  name: 'Auth',

  components: { AuthLayout, AuthRegistration, AuthLogin, AuthResetPassword },

  computed: {
    component() {
      const { path } = this.$route
      switch (path) {
        case '/auth/registration':
          return AuthRegistration
        case '/auth/login':
          return AuthLogin
        case '/auth/reset-password':
          return AuthResetPassword
        case '/auth/forgot-password':
          return AuthForgotPassword
        case '/auth/reset-password/success':
          return AuthResetPasswordSuccess
        case '/auth/confirm':
          return ConfirmEmail
        case '/auth/errors':
          return AuthErrorComponents
        case '/auth/two-factor':
          return AuthTwoFa
        default:
          return AuthLogin
      }
    }
  }
}
</script>
